module.exports = "https://coursera_assets.s3.amazonaws.com/images/c5d47f039ba64b7852443d702a26ed56.png";